var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { Toolbar as MUIToolbar, Button, Grid, } from '@mui/material';
import { SaveButton, useSaveContext, useTranslate } from 'react-admin';
import { useFormState } from 'react-hook-form';
import { NextButton } from './NextButton';
import { useWizardFormContext } from './useWizardFormContext';
/**
 * The Toolbar displayed at the bottom of WizardForm.
 *
 * @prop {boolean} hasPreviousStep Optional. Does the wizard have a previous step?
 * @prop {boolean} hasNextStep Optional. Does the wizard have a next step?
 * @prop {Function} onPreviousClick Optional. Previous button click action
 * @prop {Function} onNextClick Optional. Next button click action
 * @prop {...BaseToolbarSubmitProps}
 */
export var WizardToolbar = function (props) {
    var translate = useTranslate();
    var saveContext = useSaveContext();
    // For some reason, the SaveButton stay disabled unless we subscribe to the isDirty field here
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    var _a = useFormState(), isDirty = _a.isDirty, isValid = _a.isValid, isValidating = _a.isValidating;
    // Use form isValid, isValidating and form context saving to enable or disable the save button
    // if alwaysEnable is undefined
    var disabled = isValidating || (saveContext === null || saveContext === void 0 ? void 0 : saveContext.saving) || !isValid;
    var _b = useWizardFormContext(props), hasPreviousStep = _b.hasPreviousStep, hasNextStep = _b.hasNextStep, goToPreviousStep = _b.goToPreviousStep, goToNextStep = _b.goToNextStep;
    var handleNextClick = function (event) {
        event.preventDefault();
        goToNextStep();
    };
    var handlePreviousClick = function (event) {
        event.preventDefault();
        goToPreviousStep();
    };
    return (React.createElement(MUIToolbar, __assign({}, sanitizeRestProps(props)),
        React.createElement(Grid, { container: true, direction: "row", justifyContent: "space-between", alignItems: "center" },
            React.createElement(Grid, { item: true }, hasPreviousStep ? (React.createElement(Button, { variant: "text", onClick: handlePreviousClick }, translate('ra-form-layout.action.previous'))) : null),
            React.createElement(Grid, { item: true }, hasNextStep ? (React.createElement(NextButton, { onClick: handleNextClick, disabled: disabled })) : (React.createElement(SaveButton, null))))));
};
var sanitizeRestProps = function (_a) {
    var currentStep = _a.currentStep, goToNextStep = _a.goToNextStep, goToPreviousStep = _a.goToPreviousStep, goToStep = _a.goToStep, steps = _a.steps, rest = __rest(_a, ["currentStep", "goToNextStep", "goToPreviousStep", "goToStep", "steps"]);
    return rest;
};
